module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"username-placeholder":"请输入老账号","username-empty":"老账户为空","has-sign-up":"您已注册过金姆ID,可以直接登录","document-title":"绑定账号"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
